export async function safeAsync<T, Args extends unknown[]>(
    asyncFn: (...args: Args) => Promise<T>,
    ...args: Args
): Promise<{ result?: T; error?: Error }> {
    try {
        const result = await asyncFn(...args);
        return { result };
    } catch (error) {
        return {
            error: error instanceof Error ? error : new Error("Unknown error occurred"),
        };
    }
}
